import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import './QuantityCounter.scss';

const QuantityCounter = ({ 
  value = 0, 
  onChange, 
  step = 1, 
  min = 0, 
  disabled = false 
}) => {
  const [inputValue, setInputValue] = useState(value);

  // Синхронизация внутреннего состояния с внешним пропсом
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleDecrement = () => {
    const newValue = Math.max(min, value - step);
    onChange(newValue);
  };

  const handleIncrement = () => {
    const newValue = value + step;
    onChange(newValue);
  };

  const handleInputChange = (e) => {
    let raw = e.target.value;
    // Разрешаем цифры и одну десятичную точку
    raw = raw.replace(/[^0-9.]/g, '');
    // Убираем лишние точки (оставляем только первую)
    const firstDot = raw.indexOf('.');
    if (firstDot !== -1) {
      raw = raw.slice(0, firstDot + 1) + raw.slice(firstDot + 1).replace(/\./g, '');
    }
    // Ограничение на количество знаков после запятой (если step дробный)
    if (step < 1 && raw.includes('.')) {
      const decimalPlaces = step.toString().split('.')[1]?.length || 1;
      const parts = raw.split('.');
      if (parts[1] && parts[1].length > decimalPlaces) {
        parts[1] = parts[1].slice(0, decimalPlaces);
        raw = parts.join('.');
      }
    }
    const num = raw === '' ? 0 : parseFloat(raw);
    if (!isNaN(num)) {
      onChange(num);
    }
  };

  const handleBlur = () => {
    if (inputValue < min) {
      onChange(min);
    }
  };

  return (
    <div className="quantity-counter">
      <button 
        className="quantity-counter__button"
        onClick={handleDecrement}
        disabled={disabled || value <= min}
      >
        <Icon icon="akar-icons:minus" />
      </button>
      <div className="quantity-counter__quantity">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleBlur}
          disabled={disabled}
        />
      </div>
      <button 
        className="quantity-counter__button"
        onClick={handleIncrement}
        disabled={disabled}
      >
        <Icon icon="akar-icons:plus" />
      </button>
    </div>
  );
};

export default QuantityCounter;